import type { FC } from 'react';

import { cn } from '@repo/utils/common';

import { APP_BAR_HEIGHT_CLASS, HEADER_HEIGHT_CLASS } from '@/shared/configs/toolbar.config';

import { Container } from '@/components/common/Container';
import { BrandLockup } from '@/components/toolbar/BrandLockup';
import { WarrantyLink } from '@/components/toolbar/WarrantyLink';

/**
 * Static, in-flow stand-in for the {@link Toolbar} used by the hydrate-fallback
 * and error-boundary chrome. It reserves the same two-bar height so the layout
 * does not jump when the live Toolbar mounts, while skipping interactive
 * controls that depend on hydrated client state.
 */
export const ToolbarFallback: FC = () => (
  <div className="fixed top-0 right-0 left-0 z-10">
    <div className="bg-muted relative z-10 text-black">
      <Container className={cn('flex items-center justify-between', APP_BAR_HEIGHT_CLASS)}>
        <WarrantyLink />
        <div className="flex items-center gap-1" />
      </Container>
    </div>
    <header className="bg-secondary text-secondary-foreground">
      <Container className={cn('flex items-center justify-between', HEADER_HEIGHT_CLASS)}>
        <BrandLockup />
        <div className="flex items-center gap-3 md:gap-4" />
      </Container>
    </header>
  </div>
);
